import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {NotificationPage} from "../../multi-page-notification/multi-page-notification.component";
import {NotificationDialogContentComponent} from "../notification-dialog-content.component";
import {NotificationDto} from "homey-housing-lottery-app-dto";
import {ApplicationService} from "../../../application.service";
import {SkeletonModule} from "primeng/skeleton";

type CountsState = { type: 'loading' } | {
  type: 'loaded',
  data: {
    total: number;
    submittedOpen: number;
    submittedClosed: number;
    pendingSelection: number;
  }
};

@Component({
  selector: 'homey-application-status-update-dialog-content',
  imports: [
    NotificationDialogContentComponent,
    SkeletonModule,
  ],
  templateUrl: './application-status-update-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationStatusUpdateDialogContentComponent extends NotificationPage<null | NotificationDto> {
  private readonly applicationService = inject(ApplicationService);

  protected readonly counts = computed<CountsState>(() => {
    if (this.applicationService.applicationsFetching()) {
      return {type: 'loading'};
    }
    const apartments = this.applicationService.apartmentsWithApplicationInfo();
    if (!apartments) {
      return {type: 'loading'};
    }

    const submittedOpen = apartments.filter(
      apartment => (apartment.application?.status === 'applied' || apartment.application?.status === 'not-synced') && apartment.status === 'open'
    ).length;
    const submittedClosed = apartments.filter(
      apartment => (apartment.application?.status === 'applied' || apartment.application?.status === 'not-synced') && apartment.status === 'closed'
    ).length;
    const pendingSelection = apartments.filter(
      apartment => apartment.application?.status === 'pending-selection'
    ).length;
    const total = submittedOpen + submittedClosed + pendingSelection;

    return {
      type: 'loaded',
      data: {
        total,
        submittedOpen,
        submittedClosed,
        pendingSelection,
      }
    };
  });
}
